import GLightbox from 'glightbox';
import Accordion from './components/accordion';
import Toggler from './components/toggler';
import PopupManager from "./components/popup_manager";
function wrapWords(str, tmpl) {
	return str.replace(/\S+/g, tmpl || "<span>$&</span>");
}


document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('mark').forEach((mark) => {
		const html = wrapWords(mark.innerText);
		mark.innerHTML = html;
  })

	new Toggler('[data-toggle]');
	new PopupManager('.calendly');

	/*  document.querySelectorAll('.book-a-demo a').forEach((item) => {
    const svg = document.createElement('span');
    svg.innerHTML = `<svg width="100%" height="100%" viewBox="0 0 728 333" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-miterlimit:10;">
      <g transform="matrix(4.16667,0,0,4.16667,8.31741,370.408)">
          <path id="stroked-cta" d="M0,-87.414C30.397,-87.157 69.321,-84.955 106.271,-77.12C110.695,-76.181 123.264,-73.428 137.178,-66.659C141.327,-64.64 175.07,-48.224 170.773,-33.035C170.232,-31.125 168.517,-27.204 160.956,-22.894C120.801,0 7.39,-11.19 -0.131,-39.582C-1.286,-43.939 0.582,-47.792 1.212,-49.047C11.301,-69.123 49.802,-70.389 56.439,-70.478"  style="fill:none;fill-rule:nonzero;stroke:rgb(27,203,203);stroke-width:3px;stroke-dashoffset:447.3002014160156px;stroke-dasharray:447.3002014160156px;transition:.6s;"/>
      </g>
  </svg>`;
    item.appendChild(svg);
  }) */

	//   const calendly = document.querySelectorAll('.calendly');
	//   calendly.forEach((item) => {
	//     item.addEventListener('click', () => {
	//       window.Calendly.initPopupWidget({ url: 'https://calendly.com/tassosmorfis' });
	//       return false;
	//     });
	//   });

	const lightbox = GLightbox({
    selector: '.glidebox figure a'
	});


	const hbp = document.querySelector(".header-bp");
	const options = {
    threshold: 1
  }

	const callBack = (entries) => {
		if (!entries[0].isIntersecting) {
      document.querySelector('.site-header').classList.add('scrolled');
		} else {
      document.querySelector('.site-header').classList.remove('scrolled');
		}
	};
  const observer = new IntersectionObserver(callBack,options);
	observer.observe(hbp);



  new Accordion('.faq');

})
